// extracted by mini-css-extract-plugin
export var base = "_3z-0";
export var updateBanner = "_3z-1";